import * as types from '../types/mediaTypes';
import * as mediaService from '../../services/mediaService';

export const fetchMediaDetail = (category, id, { language, watchRegion } = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_MEDIA_DETAIL_REQUEST });
  try {
    const data = await mediaService.getMediaDetail(category, id, { language, watchRegion });
    dispatch({ type: types.FETCH_MEDIA_DETAIL_SUCCESS, payload: data || null });
  } catch (err) {
    dispatch({
      type: types.FETCH_MEDIA_DETAIL_FAILURE,
      payload: err?.response?.data?.error || err?.message || 'Failed to load title details',
    });
  }
};
